import { Component, computed, input, output } from '@angular/core';
import { IconName, provideIcons } from '@ng-icons/core';
import {
  lucideArrowRight,
  lucideBadgeCheck,
  lucideBookMarked,
  lucideBookType,
  lucideLandPlot,
  lucideLoaderCircle,
  lucideMegaphone,
  lucideNotebookText,
  lucideRoute,
  lucideSchool,
  lucideUserStar,
} from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';

export const variants = cva(
  'border-stroke-neutral-light bg-background-ground group flex h-full justify-between rounded-lg border',
  {
    variants: {
      variant: {
        default: '',
        disabled: 'opacity-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type ButtonVariants = VariantProps<typeof variants>;

@Component({
  selector: 'app-card-etape-carto',
  imports: [HlmIconImports, HlmButtonImports, HlmTooltipImports, HlmSpinnerImports],
  templateUrl: './card-etape-carto.component.html',
  providers: [
    provideIcons({
      lucideArrowRight,
      lucideUserStar,
      lucideNotebookText,
      lucideBookMarked,
      lucideLandPlot,
      lucideSchool,
      lucideLoaderCircle,
      lucideBadgeCheck,
      lucideBookType,
      lucideMegaphone,
      lucideRoute,
    }),
  ],
})
export class CardEtapeCartoComponent {
  texte = input.required<string>();
  icone = input.required<IconName>();
  disabled = input<boolean>(false);
  loadingState = input<boolean>(false);
  action = output();

  protected readonly _computedClass = computed(() =>
    hlm(variants({ variant: this.disabled() ? 'disabled' : 'default' })),
  );
}
